import { render } from "./side_drawer.vue?vue&type=template&id=ebcba672"
import script from "./side_drawer.js?vue&type=script&lang=js"
export * from "./side_drawer.js?vue&type=script&lang=js"

import "./side_drawer.vue?vue&type=style&index=0&id=ebcba672&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__